import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import AddVector from "../../../assets/Icons/Add Vector.png";
import { ICONS } from "../../../assets/Icons";
import CustomAlert from "../../../helpers/CustomAlert";
import { axiosGetApi, axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import SuccessModal from "../../../components/successModal/successModal";
import Dropdown from "../../../components/Dropdown";
import { formatDate, getTodayDate } from "../../../helpers/helper";

const ReportTypeModal = ({
  show,
  handleClose,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [lmbpList, setLmbpList] = useState([]);
  const [formData, setFormData] = useState({
    username: loggedInUserName,
    reportType: "",
    userId: "",
    fromDate: "",
    toDate: "",
  });
  const [errors, setErrors] = useState({
  reportType: "",
  fromDate: "",
  toDate: "",
  lmbpUser: "",
  });

  const handleBack = () => {
    handleClose();
    haldleSetEmptyField();
  };

  const validateFromDate = (fromDate, toDate) => {
  if (!fromDate && toDate) {
    return "From Date is required when To Date is selected";
  }

  if (fromDate && isNaN(Date.parse(fromDate))) {
    return "Invalid From Date";
  }

  if (fromDate && new Date(fromDate) > new Date()) {
    return "From Date cannot be in the future";
  }

  if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
    return "From Date must be before To Date";
  }

  return "";
};

const validateToDate = (fromDate, toDate) => {
  if (!toDate && fromDate) {
    return "To Date is required when From Date is selected";
  }

  if (toDate && isNaN(Date.parse(toDate))) {
    return "Invalid To Date";
  }

  if (toDate && new Date(toDate) > new Date()) {
    return "To Date cannot be in the future";
  }

  if (toDate && fromDate && new Date(toDate) < new Date(fromDate)) {
    return "To Date must be after From Date";
  }

  return "";
};

const handleFormSubmit = (e) => {
  e.preventDefault();
  handleSubmitt();
}

  useEffect(() => {
    fetchActiveLmbpData();
  }, []);

  const fetchActiveLmbpData = async () => {
    setLoading(true);
    try {
      const response = await axiosGetApi(`${apiList.ALL_ACTIVE_CUSTOMER_DATA}?username=${loggedInUserName}`);

      if (response?.status === 200) {
        setLmbpList(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching LMBP data:", error);
      setLoading(false);
    } finally{
      setLoading(false);
    }
  };

  const haldleSetEmptyField = () => {
  setFormData({
    username: loggedInUserName,
    reportType: "",
    userId: "",
    fromDate: "",
    toDate: "",
  });
  setErrors({});
  };

  const handleSelectReportType = async (data) => {
    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        reportType: data.reportType,
        ...(data.userId && { userId: data.userId }),
        ...(data.fromDate && { fromDate: formatDate(data.fromDate) }),
        ...(data.toDate && { toDate: formatDate(data.toDate) }),
      };
      // Make the API call
      const response = await axiosPostApi(
        apiList.PAYMENT_REPORT_REQUEST,
        payload,
      );

      if (response?.status === 200 && response?.data?.respCode === "00") {
        setShowSuccessModal(true);
        haldleSetEmptyField();
        setsuccessMessage(response?.data?.message);
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitt = () => {
  const newErrors = {};

  if (!formData.reportType) {
    newErrors.reportType = "Please select a report type.";
  }

  const fromDateError = validateFromDate(
    formData.fromDate,
    formData.toDate
  );

  const toDateError = validateToDate(
    formData.fromDate,
    formData.toDate
  );

  if (fromDateError) newErrors.fromDate = fromDateError;
  if (toDateError) newErrors.toDate = toDateError;

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) return;

  handleSelectReportType(formData);
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    handleClose(false);
  };

const isDisabled =
  loading ||
  !formData.reportType ||
  !formData.fromDate ||
  !formData.toDate;

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between gap-3 mb-2">
                <div className="flex items-center gap-3">
                  <img src={AddVector} alt="add vector" className="h-[40px]" />
                  <h5 className="modal-title main-title font-semibold">Report Type</h5>
                </div>

                {/* Right section (close button) */}
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>

              <form onSubmit={(e) => handleFormSubmit(e)}>
                <div
                  className="scoped-modal modal-body"
                >
                  <div className="row mb-3">
                    <div
                      className="col-md-6"
                      style={{ width: "95%", marginTop: "24px" }}
                    >
                        <div className="user-dropdown-division">
                            <Dropdown
                              label="Report Type"
                              value={formData.reportType}
                              onChange={(item) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  reportType: item.value,
                                }));
                                setErrors((prev) => ({ ...prev, reportType: "" }));
                              }}
                              options={[
                                { value: "LMBP", label: "LMBP" },
                                { value: "DISCREPANCY", label: "DISCREPANCY" },
                                { value: "SUMMARY", label: "SUMMARY" },
                                { value: "FULL", label: "FULL" },
                              ]}
                              error={errors.reportType}
                            />
                        </div>

                        {/* DATE SELECTOR */}
                        <div className="row mt-2">
                         <div className="col-md-6 mb-3">
                           <label className="form-label">From Date</label>
                           <input
                             type="date"
                             className="form-control"
                             value={formData.fromDate}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  fromDate: e.target.value,
                                }));
                              
                                setErrors((prev) => ({
                                  ...prev,
                                  fromDate: "",
                                }));
                              }}
                              max={getTodayDate()}
                           />
                           {errors.fromDate && (
                              <p className="text-danger text-xs mt-1">
                                {errors.fromDate}
                              </p>
                            )}
                         </div>
       
                         <div className="col-md-6 mb-3">
                           <label className="form-label">To Date</label>
                           <input
                             type="date"
                             className="form-control"
                             value={formData.toDate}
                             onChange={(e) => {
                              setFormData((prev) => ({
                                ...prev,
                                toDate: e.target.value,
                              }));
                            
                              setErrors((prev) => ({
                                ...prev,
                                toDate: "",
                              }));
                            }}
                            max={getTodayDate()}
                           />
                           {errors.toDate && (
                              <p className="text-danger text-xs mt-1">
                                {errors.toDate}
                              </p>
                            )}
                         </div>
                        </div>

                        <div className="col-md-12 mb-3">
                          <Dropdown
                            label="LMBP Name"
                            value={formData.userId}
                            onChange={(item) => {
                              setFormData((prev) => ({
                                ...prev,
                                userId: item.customerCode,
                              }));
                            }}
                            labelKey="name"
                            valueKey="customerCode"
                            options={lmbpList}
                            error={errors.lmbpUser}
                          />
                        </div>

                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px] w-[150px] h-[40px] font-semibold"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit !rounded-[8px] w-[150px] h-[40px]  font-semibold"
                    style={{
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={isDisabled}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          {showSuccessModal && (
            <SuccessModal
              show={showSuccessModal}
              handleClose={handleCloseModal}
              successMessage={successMessage}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ReportTypeModal;
